import { render, staticRenderFns } from "./21.vue?vue&type=template&id=4409797c&scoped=true&"
var script = {}
import style0 from "./21.vue?vue&type=style&index=0&id=4409797c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4409797c",
  null
  
)

export default component.exports